export default __webpack_public_path__ + "static/Toyota Certified – Horizontal 800x400-49418aa8e4b72ef7193e6d42e637763e.svg";